import React from "react";
import Typography from "./Typography";
import { Colors } from "../../config";

const FormSectionHeader = ({ label }) => {
  return (
    <div style={{ marginTop: "1rem" }}>
      <Typography
        fontColor={Colors.brandTwo}
        fontSize={"18px"}
        fontWeight={600}
      >
        {label}
      </Typography>
    </div>
  );
};

export default FormSectionHeader;
